<template>
  <div class="container-fluid">
    <card back>
      <template v-slot:header>
        <h3 v-if="$route.params.Status == 'Add'">اضافه کردن پرسشنامه جدید <i class="fad fa-plus text-info"></i></h3>
        <h3 v-else>مشاهده و ویرایش [{{ name }}] <i class="fad fa-pencile text-info"></i></h3>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row px-4" :id="$route.name">
          <div class="col-lg-4 col-12">
            <small id="lblQname">نام پرسشنامه</small>
            <input type="text" id="Qname" class="form-control required" v-model="name" />
          </div>
          <div class="col-lg-8 col-12"></div>
          <hr />
          <div class="col-12 my-4">
            <span class="Pointer" @click="AddQ"> <i class="px-3 fad fa-plus-circle text-success" style="font-size: 20px"></i></span>
            <small>لیست سوالات</small>
          </div>

          <div class="col-12 px-4 mt-2" v-for="(item, index) in QuestionList" :key="index">
            <div class="row">
              <div class="col-1">
                <span class="float-left mt-3">{{ index + 1 }} .</span>
              </div>
              <div class="col-8">
                <input type="text" class="form-control required" v-model="QuestionList[index].name" />
              </div>
              <div class="col-3 form-control text-center">
                <small id="lblShowInSlides">پرسش بله/خیر</small>

                <div class="custom-control custom-switch mt-2 d-inline">
                  <input type="checkbox" class="custom-control-input InputText" :id="'ShowInSlides' + index" v-model="QuestionList[index].code" />
                  <label class="custom-control-label mr-2" :for="'ShowInSlides' + index"> </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-8 col-12"></div>
          <div class="col-md-4 col-12 mt-2">
            <button v-if="$route.params.Status == 'Add'" class="btn btn-success w-100" @click="Submit">ثبت پرسشنــامه</button>
            <button v-else class="btn btn-warning w-100" @click="Edit">ویرایش پرسشنــامه</button>
          </div>
        </div>
      </template>
    </card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'

export default {
  data() {
    return {
      Quastionares: [],
      QuestionList: [{ Id: 0, grp: 100, name: '' }],
      newQuestion: { Id: 0, grp: 100, name: '', code: false },
      name: '',
    }
  },
  components: { Card },
  created() {
    if (this.$route.params.Status == 'Edit') {
      var DataAxios = {
        Action: 'TblCrmCombo/GetComboByParentId',
        Method: 'POST',
        ArryfildValue: {
          grp: 100,
          filter: this.QId,
        },
      }
      this.name = this.QName
      this.$PostData(DataAxios).then((result) => {
        this.QuestionList = result
      })
    }
  },
  methods: {
    AddQ() {
      this.QuestionList.push(JSON.parse(JSON.stringify(this.newQuestion)))
    },
    Submit() {
      if(this.$ValidForm(this.$route.name) == false){
        return
      }
      this.QuestionList.forEach((item) => {
        item.code ? (item.Code = 1) : (item.Code = 0)
        delete item['code']
      })
      var DataAxios = {
        Action: 'Survey/Add',
        Method: 'POST',
        ArryfildValue: {
          Name: this.name,
          Id: 0,
          tbluserGrpInsert: this.$session.get('UserInfo').tblUserGrpId,
          questions: this.QuestionList,
        },
      }

      this.$PostData(DataAxios).then((result) => {
        if (result.status == 'success') {
          this.AddMode = false
          this.$mySweetDefaultTost('عملیات موفق', 'پرسشنامه جدید با موفقیت ثبت شد', 'success', 2000)
          this.$emit('Inserted', {
            done: 'OK',
          })
        }
      })
    },
    Edit() {
      if(this.$ValidForm(this.$route.name) == false){
        return
      }
      this.QuestionList.forEach((item) => {
        item.code ? (item.Code = 1) : (item.Code = 0)
        delete item['code']
      })
      var DataAxios = {
        Action: 'Survey/Edit',
        Method: 'Post',
        ArryfildValue: {
          Name: this.name,
          Id: this.QId,
          tbluserGrpInsert: this.$session.get('UserInfo').tblUserGrpId,
          questions: this.QuestionList,
        },
      }
      DataAxios.ArryfildValue.Id = this.QId
      // console.log(DataAxios)
      this.$PostData(DataAxios).then((result) => {
        if (result.status == 'success') {
          this.AddMode = false
          this.$mySweetDefaultTost('عملیات موفق', 'پرشسنامه با موفقیت ویرایش شد', 'success', 2000)
          this.$emit('Inserted', {
            done: 'OK',
          })
        } else {
          this.$mySweetDefaultTost('عملیات موفق', result.msg, 'warning', 2000)
        }
      })
    },
  },
  props: ['QId', 'QName'],
}
</script>
